import { AxiosAuth } from "../axios";
import { AppRouteApi } from "../../config/appRoute";
import { ApiResponseContainer } from "../../models/api";
import { showErrorToast } from "../../components/toast.component";
import { StorageAuth } from "../localStorage/StorageAuth";

async function ChangePasswordApi({
  newPassword,
  confirmPassword,
}: {
  confirmPassword: string;
  newPassword: string;
}): Promise<boolean> {
  const emailAddress = StorageAuth.Email;

  try {
    const response = await AxiosAuth.post<
      ApiResponseContainer<{
        id: string;
        emailAddress: string;
        message: string;
      }>
    >(AppRouteApi.Auth.ChangePassword(), {
      newPassword,
      confirmPassword,
      emailAddress,
    });
    return !!response.data.isSuccess;
  } catch (e: any) {
    showErrorToast({ isSuccess: false, ...JSON.parse(e.message).data });
  }
  return false;
}

const ActivateUser = async (userName: string) => {
  const res = await AxiosAuth.post<ApiResponseContainer<null>>(
    AppRouteApi.Auth.ActivateUser(),
    {},
    { params: { userName } }
  );
  return res.data.isSuccess;
};

export const ApiAuth = {
  ChangePasswordApi,
  ActivateUser,
};
